import { ReactNode } from "react";
import { Link } from "react-router-dom";
import IntelligenceTopBar from "./IntelligenceTopBar";
import InstallBanner from "./InstallBanner";
import B2BWaitlistModal from "./B2BWaitlistModal";

interface CommandLayoutProps {
  children: ReactNode;
}

const CommandLayout = ({ children }: CommandLayoutProps) => {
  return (
    <div className="flex flex-col min-h-[100dvh] w-full bg-background">
      {/* Gradient background */}
      <div
        className="fixed inset-0 pointer-events-none"
        style={{
          background: "linear-gradient(180deg, hsl(0 0% 10%) 0%, hsl(0 0% 5%) 100%)",
        }}
      />

      {/* Subtle cyan glow at top */}
      <div
        className="fixed top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[600px] pointer-events-none opacity-10"
        style={{
          background: "radial-gradient(ellipse at center, hsl(184 100% 50% / 0.4) 0%, transparent 70%)",
        }}
      />

      <IntelligenceTopBar />

      {/* Main Content - full width with readable max-width */}
      <main className="flex-1 relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 py-6"
        style={{ paddingBottom: "max(env(safe-area-inset-bottom), 16px)" }}
      >
        {children}
      </main>

      <InstallBanner />

      {/* Footer */}
      <footer className="relative z-10 border-t border-border px-4 py-4 text-center space-y-2">
        <div className="flex flex-wrap items-center justify-center gap-4 text-xs">
          <Link to="/about" className="text-muted-foreground hover:text-cyan transition-colors">About</Link>
          <span className="text-muted-foreground/40">•</span>
          <Link to="/contact" className="text-muted-foreground hover:text-cyan transition-colors">Contact</Link>
          <span className="text-muted-foreground/40">•</span>
          <Link to="/privacy" className="text-muted-foreground hover:text-cyan transition-colors">Privacy Policy</Link>
          <span className="text-muted-foreground/40">•</span>
          <Link to="/professionals" className="text-muted-foreground hover:text-cyan transition-colors">For Professionals</Link>
          <span className="text-muted-foreground/40">•</span>
          <Link to="/terms" className="text-muted-foreground hover:text-cyan transition-colors">Terms of Service</Link>
          <span className="text-muted-foreground/40">•</span>
          <Link to="/refunds" className="text-muted-foreground hover:text-cyan transition-colors">Refund Policy</Link>
        </div>
        <p className="text-xs text-muted-foreground">© 2026 GreyRock AI®. All Rights Reserved.</p>
      </footer>

      <B2BWaitlistModal />
    </div>
  );
};

export default CommandLayout;
